<section class="page-constructor-container"
         id="page-constructor">
  <div class="page-container"
       [class.selected]="tourEnum.PAGE_BUILDER === (builderHistoryService.tourStep|async)">
    <db-page-title [loading]="loading"
                   [sectionsLimit]="sectionsLimit"
                   [isMobile]="isMobile"
                   [generating]="sectionLoading"
                   (openSectionTemplates)="openSectionTemplates()">
    </db-page-title>
    <div class="page-body"
         (click)="checkMobileClick()"
         (dbClickOutside)="resetSelection()">
      <div *ngIf="staticSections[0]"
           [class.disabled]="disabledSteps.includes(builderHistoryService.tourStep|async) || !!isMobile"
           [class.selected]="staticSections[0].id === selectedSection?.id"
           (click)="selectSection(staticSections[0], 0, false); pageInteractionsService.closeAll()"
           class="page-section-item static">
        <db-page-section [static]="true"
                         (isEdit)="isEdit = $event"
                         (valueChange)="sectionValueChange($event, staticSections[0], 0, true)"
                         [selected]="staticSections[0].id === selectedSection?.id"
                         [titleControl]="staticSections[0].title_control"
                         [descriptionControl]="staticSections[0].description_control"
                         [section]="staticSections[0]">
        </db-page-section>
        <div class="add-section-below-btn"
             [class.disabled]="!(_sectionsInteractionsService.canAddSection|async)"
             [dsTooltip]="(_sectionsInteractionsService.canAddSection|async) ? '' : ('text_limitAddSection'|dbText: {count:sectionsLimit})"
             dsTooltipSize="medium"
             dsTooltipPosition="bottom"
             dsTooltipColor="black"
             (click)="$event.stopPropagation();onClickAddSection(0, staticSections[0])">
          <i class="db-icon db-icon-ds-sharp-plus"></i>
        </div>
      </div>
      <div [dragulaModel]="draggableSections"
           *ngIf="draggableSections.length"
           class="draggable-sections"
           (dragulaModelChange)="onStructureChange($event)"
           [dragula]="'sections'">
        <ng-container *ngFor="let section of draggableSections; let i = index">
          <div [class.tempo]="section.is_tempo"
               [class.disabled]="disabledSteps.includes(builderHistoryService.tourStep|async) || !!isMobile"
               [id]="section.id"
               [class.section-loading]="section.loading"
               [class.selected]="section.id === selectedSection?.id"
               (contextmenu)="rightClick($event, section, i)"
               dbClassChangeObserver
               (classChanged)="dragClassChanged()"
               (click)="selectSection(section, i)"
               class="page-section-item" [ngClass]="{
             'generating':section.loading,
             'dragging': isDragging
             }">
            <div>
              <db-page-section
                [id]="i"
                [builderStep]="(builderHistoryService.tourStep|async) === tourEnum.PAGE_BUILDER"
                [static]="false"
                (isEdit)="onSectionEdit($event)"
                [selected]="section.id === selectedSection?.id"
                (valueChange)="sectionValueChange($event, section, i+1)"
                [titleControl]="section.title_control"
                [descriptionControl]="section.description_control"
                [section]="section">
              </db-page-section>
              <div class="drag-section-btn handle">
                <i class="db-icon db-icon-ds-drag handle"></i>
              </div>
              <div class="add-section-below-btn"
                   [class.disabled]="!(_sectionsInteractionsService.canAddSection|async) || loading"
                   [dsTooltip]="(_sectionsInteractionsService.canAddSection|async) ? '' : ('text_limitAddSection'|dbText: {count:sectionsLimit})"
                   dsTooltipSize="medium"
                   dsTooltipPosition="bottom"
                   dsTooltipColor="black"
                   (click)="$event.stopPropagation();onClickAddSection(i)">
                <i class="db-icon db-icon-ds-sharp-plus"></i>
              </div>
            </div>
            <div *ngIf="section.loading"
                 class="section-loading-container">
              <img src="assets/images/icons/enhance_with_ai_active.svg" alt="generate">
              Generating
              <div class="loader">
                <span>...</span>
              </div>
            </div>
          </div>
          <div *ngIf="tempoSection && tempoSection?.index === (i+1)"
               class="tempo page-section-item">
            <div>
              <db-page-section
                [section]="tempoSection">
              </db-page-section>
            </div>
            <div *ngIf="section.loading"
                 class="section-loading-container">
              <img src="assets/images/icons/enhance_with_ai_active.svg" alt="generate">
              Generating
              <div class="loader">
                <span>...</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <ng-container *ngIf="draggableSections.length === 0 && tempoSection && tempoSection?.index === 0">
        <div class="draggable-sections">
          <div class="tempo page-section-item">
            <div>
              <db-page-section
                [section]="tempoSection">
              </db-page-section>
            </div>
            <div *ngIf="tempoSection.loading"
                 class="section-loading-container">
              <img src="assets/images/icons/enhance_with_ai_active.svg" alt="generate">
              Generating
              <div class="loader">
                <span>...</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <db-sceleton-loading *ngIf="loading"></db-sceleton-loading>
      <div *ngIf="staticSections[1]"
           [class.disabled]="disabledSteps.includes(builderHistoryService.tourStep|async) || !!isMobile"
           [class.selected]="staticSections[1].id === selectedSection?.id"
           (click)="selectSection(staticSections[1], 1, false); pageInteractionsService.closeAll()"
           class="page-section-item static">
        <db-page-section [static]="true"
                         (isEdit)="isEdit = $event"
                         (valueChange)="sectionValueChange($event, staticSections[1], pageSections.length-1, true)"
                         [selected]="staticSections[1].id === selectedSection?.id"
                         [titleControl]="staticSections[1].title_control"
                         [descriptionControl]="staticSections[1].description_control"
                         [section]="staticSections[1]">
        </db-page-section>
      </div>
    </div>
  </div>
</section>
